<template>
    <div>
         <!-- 第一部分 -->
    <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain_box">
              <span class="title_intro_box">创新产品/</span>
              <span class="title_en_box">迷你双色编织球 </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1200px">
          <img
            src="../assets/SmartBonesInnovation01.png"
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 900px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
          <strong style="font-size: 20px; color: #2963a4">精致且惊喜！<br>
            最好的零食给最爱的ta!<br></strong>
            SmartBones迷你双色编织球独特设计，不仅有有趣的外表，还有精致的灵魂。<br>
        
        球内包裹着纯鸡肉粒零食，增加狗狗趣味觅食娱乐时间。<br>
    
        好吃又好玩，SmartBones精心陪伴ta!<br>
    
    <strong>迷你双色编织球有2种口味可供选择：</strong>
          </p>
        </div>
        <div style="width: 1200px;margin-top: 30px;">
          <img
            src="../assets/SmartBonesInnovation02.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

           <!-- 标题 -->
           <div class="title" style="margin-top: 60px;">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">产品介绍</span>
              <span class="title_en">Product Introduction</span>
            </div>
          </div>
        </div>
        <div style="width: 1200px;margin-top: 30px;">
          <img
            src="../assets/SmartBonesInnovation03.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>
    </div>  


 <!-- 第二部分 -->
 <div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain_box">
              <span class="title_intro_box">创新产品/</span>
              <span class="title_en_box">夹芯粗皮卷 </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1200px">
          <img
            src="../assets/SmartBonesInnovation04.png"
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 900px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
          <strong style="font-size: 20px; color: #2963a4">鲜肉生香
        <br>
        汪星人的挚爱食谱
        <br></strong>
        特别添加新鲜猪肉配方，优质的肉类中含有高蛋白质，提高狗狗营养吸收率。<br>
      
      用有益健康的新鲜蔬菜和鸡肉做成，富含多种维生素和矿物质，<br>
    
      给予从食物源头到汪星人嘴边的美味。<br>
    
    <strong>夹芯粗皮卷有2种口味可供选择: </strong>
          </p>
        </div>
        <div style="width: 1200px;margin-top: 30px;">
          <img
            src="../assets/SmartBonesInnovation05.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

           <!-- 标题 -->
           <div class="title" style="margin-top: 60px;">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">产品介绍</span>
              <span class="title_en">Product Introduction</span>
            </div>
          </div>
        </div>
        <div style="width: 1200px;margin-top: 30px;">
          <img
            src="../assets/SmartBonesInnovation06.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>
    </div>  

   <!-- 第三部分 -->
   <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain_box">
              <span class="title_intro_box">创新产品/</span>
              <span class="title_en_box">夹芯卷棒/夹芯洁齿骨 </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1200px">
          <img
            src="../assets/SmartBonesInnovation07.png"
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 900px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
          <strong style="font-size: 20px; color: #2963a4"> 夹芯咀嚼更持久
            <br>
            不含生皮好消化
            <br></strong>
        
            狗狗连续啃食磨牙，能有效清洁爱犬口腔卫生，清楚牙龈异物，预防口臭，狗狗牙结石不再继续发展，口味更清新，牙齿更健康。<br>
        
            营养全面丰富，加上超强的柔软度，狗狗食用起来，美味不急躁！
            <br>
        
        <strong>夹芯系列有2种口味可供选择：</strong>
          </p>
        </div>
        <div style="width: 1200px;margin-top: 30px;">
          <img
            src="../assets/SmartBonesInnovation08.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

           <!-- 标题 -->
           <div class="title" style="margin-top: 60px;">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">产品介绍</span>
              <span class="title_en">Product Introduction</span>
            </div>
          </div>
        </div>
        <div style="width: 1200px;margin-top: 30px;">
          <img
            src="../assets/SmartBonesInnovation09.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>
    </div>  

    <!-- 底部栏 -->
    <foot></foot>

    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
        .w {
  width: 1200px;
  margin: 0 auto;
}

.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-center {
  justify-content: center;
}
.banner {
  width: 100%;
}
.first_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}

.title {
  width: 1200px;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.titleBox {
  padding: 4px 0;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .title_contain_box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    letter-spacing: 1.2px;
    padding: 20px 200px;
    background-color: #2963a4;
    .title_intro_box {
      font-size: 46px;
      color: #fff;
      font-weight: 600;
      text-align: center;
    }
    .title_en_box {
      font-size: 35px;
      letter-spacing: 0.02em;
      text-align: center;
      color: #fff;
    }
  }
}

.second_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #fff;
}

.third_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}

.titleBox {
  padding: 4px 0;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .title_contain {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 20px;
    border-bottom: 5px solid #2963a4;
    .title_intro {
      font-size: 46px;
      color: #333;
      font-weight: 600;
      text-align: center;
    }
    .title_en {
      font-size: 35px;
      letter-spacing: 0.02em;
      text-align: center;
      color: #999;
    }
  }
}
</style>